import {TableHeaderColumn as TableHeaderColumnRoot} from './table-header-column';
import {TableHeaderColumnSortable} from './table-header-column-sortable';

export const TableHeaderColumn = Object.assign(TableHeaderColumnRoot, {
	Sortable: TableHeaderColumnSortable,
});

export {SortDirection} from './table-header-column-sortable';
export {useSortableColumns} from './use-sortable-column';
